import * as apiClient from '../../services/api-client';
import * as FirestoreService from '../../services/firestore';


export const getUserMe = async (store) => {
    const user = await apiClient.users.getUserMe(store.state.auth.token);
    store.setState({ user });
};

export const getUserById = async (store, userId) => {
    const user = await apiClient.users.getUser(userId, store.state.auth.token);
    store.setState({ user });
};

export const createUser = async (store, userData) => {
    const auth = await apiClient.users.createUser(userData);
    if(typeof auth === 'string') {
        let notification = {
            place: 'tc',
            message: 'Unable to create account.',
            type: 'danger',
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        }; 
        store.setState({ notification });
        return;
    }
    store.setState({ auth });
};

export const updateUser = async (store, data) => {
    const user = await apiClient.users.updateUser(store.state.auth.user_id, data, store.state.auth.token);
    store.setState({ user });
    const response = {
        type: "userupdated",
        data: user
    }
    store.setState({ response });
};

export const getUserTracking = async (store, period='this-month', startDate=null, endDate=null) => {

    if(period === 'this-month') {
        //check if there's data in firebase...
        const querySnapshot = await FirestoreService.getUserTracking(store.state.user.id);
        //if so...
        if(!querySnapshot.empty) {
            console.log('FIREBASE DOCUMENTS FOUND!');
            await apiClient.users.migrateUserTracking(store.state.user.id, store.state.auth.token);
            console.log('MIGRATING LATEST USER TRACKING DATA');
        }
    }

    const trackingData = await apiClient.users.getUserTracking(store.state.user.id, period, store.state.auth.token);
    let tracking = {
        ...store.state.tracking
    }
    tracking[period] = trackingData;
    
    // if(period === 'this-month') {
    //     console.log('PRE FIREBASE TRACKING....', tracking[period]);
    //     console.log('now get firebase data....' + store.state.user.id);
    //     const querySnapshot = await FirestoreService.getUserTracking(store.state.user.id);
    //     let firebaseData = [];
    //     querySnapshot.forEach((doc) => {
    //         // doc.data() is never undefined for query doc snapshots
    //         console.log(doc.id, " => ", doc.data().data);
    //         let docData = doc.data();
    //         if(!docData.data) {
    //             return;
    //         }
    //         firebaseData.push(docData.data);

    //         //update raw array
    //         let rawIdx = tracking[period].raw.filter(d => d.content_hash).lastIndexOf(docData.data.url);
    //         let newContent = true;
    //         let newCharge = 0;
    //         let newConsumed = 0;
    //         if(rawIdx >= 0) {
    //             newContent = false;
    //             newCharge = docData.data.charged - tracking[period].raw[rawIdx].charged;
    //             newConsumed = docData.data.percent_consumed - tracking[period].raw[rawIdx].percent_consumed;
    //             tracking[period].raw[rawIdx].percent_consumed = docData.data.percent_consumed;
    //             tracking[period].raw[rawIdx].percent_consumed_end = docData.data.percent_consumed_end;
    //             tracking[period].raw[rawIdx].percent_consumed_start = docData.data.percent_consumed_start;
    //             tracking[period].raw[rawIdx].charged = docData.data.charged;
    //         } else {
    //             tracking[period].raw.push({
    //                 business_app_id: docData.data.app_id,
    //                 charged: docData.data.charged,
    //                 content_hash: docData.data.url,
    //                 date_created: new Date(docData.data.timestamp.seconds * 1000),
    //                 date_updated: new Date(docData.data.timestamp.seconds * 1000),
    //                 day_utc: docData.data.day_utc,
    //                 experiment: docData.data.experiment,
    //                 percent_consumed: docData.data.percent_consumed,
    //                 percent_consumed_end: docData.data.percent_consumed_end,
    //                 percent_consumed_start: docData.data.percent_consumed_start,
    //                 title: docData.data.url
    //             });
    //         }
    //         //update daily arrays
    //         let totalConsumed = 0;
    //         let dailyIdx = tracking[period].daily.map(d => d.day_consumed).indexOf(docData.data.day_utc);
    //         if(dailyIdx >= 0) {
    //             totalConsumed = tracking[period].daily[dailyIdx].avg_consumed * tracking[period].daily[dailyIdx].total_content;
    //             if(newContent) {
    //                 tracking[period].daily[dailyIdx].total_charged += docData.data.charged;
    //                 tracking[period].daily[dailyIdx].total_content += 1;
    //                 tracking[period].daily[dailyIdx].avg_consumed = (totalConsumed + docData.data.percent_consumed) / tracking[period].daily[dailyIdx].total_content;
    //             } else {
    //                 tracking[period].daily[dailyIdx].total_charged += newCharge;
    //                 tracking[period].daily[dailyIdx].avg_consumed = (totalConsumed + newConsumed) / tracking[period].daily[dailyIdx].total_content;
    //             }
                
    //         }

    //         //update sites arrays
    //         let sitesIdx = tracking[period].sites.map(s => s.app_id).indexOf(docData.data.app_id);
    //         if(sitesIdx >= 0) {
    //             totalConsumed = tracking[period].sites[sitesIdx].avg_consumed * tracking[period].sites[sitesIdx].total_content;
    //             tracking[period].sites[sitesIdx].total_charged += docData.data.charged;
    //             if(newContent) {
    //                 tracking[period].sites[sitesIdx].total_content += 1;
    //             }
    //             tracking[period].sites[sitesIdx].avg_consumed = (totalConsumed + docData.data.percent_consumed) / tracking[period].sites[sitesIdx].total_content;
    //         }
    //     });
    //     // firebaseData = firebaseData.map(row => {
    //     //     return {
    //     //         business_app_id: row.app_id,
    //     //         charged: row.charged,
    //     //         content_hash: row.url,
    //     //         date_created: new Date(row.timestamp.seconds * 1000),
    //     //         date_updated: new Date(row.timestamp.seconds * 1000),
    //     //         day_utc: row.day_utc,
    //     //         experiment: row.experiment,
    //     //         percent_consumed: row.percent_consumed,
    //     //         percent_consumed_end: row.percent_consumed_end,
    //     //         percent_consumed_start: row.percent_consumed_start,
    //     //         title: row.url
    //     //     }
    //     // });
    //     // tracking[period].raw = [
    //     //     ...tracking[period].raw,
    //     //     ...firebaseData
    //     // ];

    //     console.log('NOW SET THE ADJUSTED DATA', tracking[period]);
    //     return;
    // }
    store.setState({ tracking });
};

export const getUserBudgets = async (store) => {
    const budgets = await apiClient.users.getUserBudgets(store.state.user.id, store.state.auth.token);
    store.setState({ budgets });
};

export const createUserBudget = async (store, budgetData) => {
    budgetData.user_id = store.state.user.id;
    const newBudget = await apiClient.users.createUserBudget(store.state.user.id, budgetData, store.state.auth.token);
    const budgets = [ ...store.state.budgets, newBudget ];
    store.setState({ budgets });
};

export const removeUserBudget = async (store, budgetId) => {
    await apiClient.users.deleteUserBudget(store.state.user.id, budgetId, store.state.auth.token);
    let idx = store.state.budgets.map(b => b.id).indexOf(budgetId);
    let budgets = [ 
        ...store.state.budgets.slice(0,idx), 
        ...store.state.budgets.slice(idx+1) 
    ];
    store.setState({ budgets });
};

export const getUserInvoices = async (store) => {
    const invoices = await apiClient.users.getUserInvoices(store.state.user.id, store.state.auth.token);
    store.setState({ invoices });
};

export const createUserPaymentMethod = async (store, paymentMethodData) => {
    const userData = await apiClient.users.createUserPaymentMethod(store.state.user.id, paymentMethodData, store.state.auth.token);
    let user = {
        ...store.state.user,
        ...userData
    }
    store.setState({ user });

    let notification = {
        place: 'tc',
        message: 'New Payment Method Added',
        type: 'success',
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 7
    }; 
    store.setState({ notification });
}